import { Box, Link as MuiLink, SvgIcon, alpha, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

import { getSocialLinkIcon } from '~/features/chatbot/components/socialLinks/utils'
import { TLink } from '~/features/settings/models'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  links: TLink[]
}

function SocialLinks({ links }: TProps) {
  const theme = useTheme()
  const chatbotLayout = store((state) => state.chatbot.layout)
  const backgroundColor = theme.palette.secondary1

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {links.map((link) => {
        const socialIcon = getSocialLinkIcon(link.url)
        return (
          socialIcon && (
            <MuiLink
              component={Link}
              key={link.url}
              to={link.url}
              target="_blank"
              sx={{ height: rem(27) }}
            >
              <SvgIcon
                sx={{
                  fontSize: 27,
                  color: theme.palette.common.white,
                  backgroundColor,
                  borderRadius: '50%',
                  border: `${rem(2)} solid ${chatbotLayout.selection[chatbotLayout.selection.theme]}`,
                  padding: rem(3),
                  '&:hover': {
                    backgroundColor: alpha(backgroundColor, 0.2),
                    cursor: 'pointer',
                    transform: 'scale(1.1)',
                  },
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                {socialIcon}
              </SvgIcon>
            </MuiLink>
          )
        )
      })}
    </Box>
  )
}

export default SocialLinks
